// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.agreement{
    margin-right: 60px;

}


.agreement>div:nth-child(1)>div:nth-child(1){
    height: calc(100vh - 520px);
    overflow-y: scroll;

}


.agreement>div:nth-child(1)>div::-webkit-scrollbar {
    width: 0; /* Set the width of the scrollbar to a minimal value */
  }
  
  .agreement>div:nth-child(1)>div::-webkit-scrollbar-thumb {
    background: none; /* Set the scrollbar thumb to be transparent */
  }

.agreement tr,.agreement td{
    border: 1px solid gray;
}

.input-agreement
{
    color: rgb(55 65 81 / 1);
    /* border-width: 1px; */
    background:#fcfcfd;
    border: 1px solid #e5e7eb;
    
    width: 90%;
    margin-bottom: 10px;
    margin-top: 10px;
    line-height: 1.25;
    align-items: center;
    border-radius: 5px;
    padding: 10px 5px;
    padding-left: 20px;
}




.label{
    color: rgb(107 114 128 / 1);
    margin-top: 10px;
    margin-bottom: 10px;
}

.edit-label{
   color: #4b99ff;
   margin-top: 5px;
   font-weight: 700;
   font-size: 13px;
}

.edit-pop{
    padding: 10px 20px;
    background-color: white;
    box-shadow: 0px 0px 5px #e6e7ec;
    border-radius:5px ;
}

.edit-button{
    background-color: #1677ff;
    padding:3px 10px;
    color: white;
    border: none;
    border-radius: 5px;
    z-index: 99;
}

.edit-icon{
    cursor: pointer;
}

.agreement-button{
    float:right;
    margin-top: 20px;
}

.agreement-button>button:nth-child(1){
    color: #1677ff;
    border: none;
    background-color: none;
    background: none;
    padding: 10px;
    cursor: pointer;
}
.agreement-button>button:nth-child(3){
    color: #1677ff;
    border: none;
    background-color: none;
    background: none;
    padding: 10px;
    cursor: pointer;
}

.agreement-button>button:nth-child(2){
    background-color: #1677ff;
    padding: 10px;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;

}

.other-details{
    height: calc(100vh - 270px);
    overflow-y: scroll;

    overflow-x: hidden;
}


.other-details::-webkit-scrollbar {
    width: 0; /* Set the width of the scrollbar to a minimal value */
  }
  
  .other-details::-webkit-scrollbar-thumb {
    background: none; /* Set the scrollbar thumb to be transparent */
  }


  .box-shape{
    display:flex;
    justify-content:space-between;
    align-items: center;
     background:#fcfcfd;
     padding:5px 20px;
     border: 1px solid #e5e7eb;
     border-radius:5px;
     margin-top: 20px;
     margin-bottom: 20px;
}

.box-shape>div{
    color: rgb(55 65 81 / 1);
}

.attachment-button{
    /* background-color:
 #4a97ff; */
}


input[type="file"] {
    display: none;
  }
  
  .custom-file-upload {
    /* border: 1px solid #ccc; */
    background-color: #1677ff;
    display: inline-block;
    padding: 6px 12px;
    cursor: pointer;
    border-radius: 3px;
    color: white;
  }

  /* Organ pills styling */
  .organ-pill {
    padding: 5px 10px;
    background-color: #e3f2fd;
    border-radius: 15px;
    fontSize: 12px;
    border: 1px solid #90caf9;
    display: inline-block;
    margin-bottom: 5px;
    transition: all 0.3s ease;
  }

  .organ-pill:hover {
    background-color: #bbdefb;
    transform: scale(1.05);
  }`, "",{"version":3,"sources":["webpack://./src/components/Hospital/AgreementPricing.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;;AAEtB;;;AAGA;IACI,2BAA2B;IAC3B,kBAAkB;;AAEtB;;;AAGA;IACI,QAAQ,EAAE,sDAAsD;EAClE;;EAEA;IACE,gBAAgB,EAAE,8CAA8C;EAClE;;AAEF;IACI,sBAAsB;AAC1B;;AAEA;;IAEI,wBAAwB;IACxB,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;;IAEzB,UAAU;IACV,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;;;;;AAKA;IACI,2BAA2B;IAC3B,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;GACG,cAAc;GACd,eAAe;GACf,gBAAgB;GAChB,eAAe;AAClB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;IACb,eAAe;AACnB;AACA;IACI,cAAc;IACd,YAAY;IACZ,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;;AAEnB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;;IAElB,kBAAkB;AACtB;;;AAGA;IACI,QAAQ,EAAE,sDAAsD;EAClE;;EAEA;IACE,gBAAgB,EAAE,8CAA8C;EAClE;;;EAGA;IACE,YAAY;IACZ,6BAA6B;IAC7B,mBAAmB;KAClB,kBAAkB;KAClB,gBAAgB;KAChB,yBAAyB;KACzB,iBAAiB;KACjB,gBAAgB;KAChB,mBAAmB;AACxB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI;WACO;AACX;;;AAGA;IACI,aAAa;EACf;;EAEA;IACE,4BAA4B;IAC5B,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,YAAY;EACd;;EAEA,wBAAwB;EACxB;IACE,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;EACxB","sourcesContent":[".agreement{\n    margin-right: 60px;\n\n}\n\n\n.agreement>div:nth-child(1)>div:nth-child(1){\n    height: calc(100vh - 520px);\n    overflow-y: scroll;\n\n}\n\n\n.agreement>div:nth-child(1)>div::-webkit-scrollbar {\n    width: 0; /* Set the width of the scrollbar to a minimal value */\n  }\n  \n  .agreement>div:nth-child(1)>div::-webkit-scrollbar-thumb {\n    background: none; /* Set the scrollbar thumb to be transparent */\n  }\n\n.agreement tr,.agreement td{\n    border: 1px solid gray;\n}\n\n.input-agreement\n{\n    color: rgb(55 65 81 / 1);\n    /* border-width: 1px; */\n    background:#fcfcfd;\n    border: 1px solid #e5e7eb;\n    \n    width: 90%;\n    margin-bottom: 10px;\n    margin-top: 10px;\n    line-height: 1.25;\n    align-items: center;\n    border-radius: 5px;\n    padding: 10px 5px;\n    padding-left: 20px;\n}\n\n\n\n\n.label{\n    color: rgb(107 114 128 / 1);\n    margin-top: 10px;\n    margin-bottom: 10px;\n}\n\n.edit-label{\n   color: #4b99ff;\n   margin-top: 5px;\n   font-weight: 700;\n   font-size: 13px;\n}\n\n.edit-pop{\n    padding: 10px 20px;\n    background-color: white;\n    box-shadow: 0px 0px 5px #e6e7ec;\n    border-radius:5px ;\n}\n\n.edit-button{\n    background-color: #1677ff;\n    padding:3px 10px;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    z-index: 99;\n}\n\n.edit-icon{\n    cursor: pointer;\n}\n\n.agreement-button{\n    float:right;\n    margin-top: 20px;\n}\n\n.agreement-button>button:nth-child(1){\n    color: #1677ff;\n    border: none;\n    background-color: none;\n    background: none;\n    padding: 10px;\n    cursor: pointer;\n}\n.agreement-button>button:nth-child(3){\n    color: #1677ff;\n    border: none;\n    background-color: none;\n    background: none;\n    padding: 10px;\n    cursor: pointer;\n}\n\n.agreement-button>button:nth-child(2){\n    background-color: #1677ff;\n    padding: 10px;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n\n}\n\n.other-details{\n    height: calc(100vh - 270px);\n    overflow-y: scroll;\n\n    overflow-x: hidden;\n}\n\n\n.other-details::-webkit-scrollbar {\n    width: 0; /* Set the width of the scrollbar to a minimal value */\n  }\n  \n  .other-details::-webkit-scrollbar-thumb {\n    background: none; /* Set the scrollbar thumb to be transparent */\n  }\n\n\n  .box-shape{\n    display:flex;\n    justify-content:space-between;\n    align-items: center;\n     background:#fcfcfd;\n     padding:5px 20px;\n     border: 1px solid #e5e7eb;\n     border-radius:5px;\n     margin-top: 20px;\n     margin-bottom: 20px;\n}\n\n.box-shape>div{\n    color: rgb(55 65 81 / 1);\n}\n\n.attachment-button{\n    /* background-color:\n #4a97ff; */\n}\n\n\ninput[type=\"file\"] {\n    display: none;\n  }\n  \n  .custom-file-upload {\n    /* border: 1px solid #ccc; */\n    background-color: #1677ff;\n    display: inline-block;\n    padding: 6px 12px;\n    cursor: pointer;\n    border-radius: 3px;\n    color: white;\n  }\n\n  /* Organ pills styling */\n  .organ-pill {\n    padding: 5px 10px;\n    background-color: #e3f2fd;\n    border-radius: 15px;\n    fontSize: 12px;\n    border: 1px solid #90caf9;\n    display: inline-block;\n    margin-bottom: 5px;\n    transition: all 0.3s ease;\n  }\n\n  .organ-pill:hover {\n    background-color: #bbdefb;\n    transform: scale(1.05);\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
